import { render } from "./GovernmentBodies.vue?vue&type=template&id=a1b20146&scoped=true&lang=html"
import script from "./GovernmentBodies.vue?vue&type=script&lang=js"
export * from "./GovernmentBodies.vue?vue&type=script&lang=js"

import "./GovernmentBodies.vue?vue&type=style&index=0&id=a1b20146&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b20146"]])

export default __exports__